import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';

export default class PartGoodReceiptDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partGoodReceiptId  = '';
		this.partGoodReceiptPurchaseOrder = '';
		this.purchaseOrderDetailId  = '';
		this.purchaseOrderDetailQtyPo = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtyOutstandingBefore = '';
		this.qtyReceived = '';
		this.qtyActual = '';
		this.qtyOutstandingAfter = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partGoodReceiptId : '0',
			partGoodReceiptPurchaseOrder : '0',
			purchaseOrderDetailId : '0',
			purchaseOrderDetailQtyPo : '0',
			partId : '0',
			partPartNumber : '0',
			qtyOutstandingBefore : '0',
			qtyReceived : '0',
			qtyActual : '0',
			qtyOutstandingAfter : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}